<!--The content below is only a placeholder and can be replaced.-->
<div class="loginPage">
  <form (ngSubmit)="Authenticate('')" ngNativeValidate #loginForm="ngForm" method="POST">
    <!-- <h1 style="text-align: center; font-weight:600" title="{{version}}">
      CatchHub
    </h1> -->
    <div class="catchLogo">
      <img class="logo" src="assets/images/frankly.png" alt="CatchHub" />
    </div>
    <div>
      <mat-form-field style="height: 80px; margin-bottom: 8px; width: 100%" appearance="fill">
        <mat-label>Username:</mat-label>
        <input matInput class="" id="username" required type="text" placeholder="Username" [(ngModel)]="username" name="username" />
      </mat-form-field>

      <mat-form-field style="height: 80px; margin-bottom: 15px; width: 100%" appearance="fill">
        <mat-label>Password:</mat-label>
        <input matInput class="" id="password" placeholder="Password" required type="password" [(ngModel)]="password" (focus)="showInvalidCredentialMessage = false" name="password" />
      </mat-form-field>

      <div style="text-align: center">
        <button class="loginButton" mat-button type="submit" id="btnLogin" name="submit">Login</button>
        <!-- <br />
        <button style="display: none" *ngIf="!isAuthenticated && isThirdPartyLoginAllow" class="loginButton" mat-raised-button color="primary" (click)="login()" matTooltip="Login with Okta">
          Login with Organisation
        </button> -->
      </div>

      <div [hidden]="!showInvalidCredentialMessage" style="color: #c1272c; font-size: 12px; text-align: center" role="alert">
        <span>Invalid username or password</span>
      </div>

      <div [hidden]="!loginError.message" style="color: #c1272c; font-size: 12px; text-align: center" role="alert">
        <span>{{ loginError.message }}</span>
      </div>

      <div style="padding-left: 48px; margin-bottom: 10px">
        <div style="display: flex; justify-content: space-between; max-width: 350px">
          <div class="forgotPassword">
            <a class="clickHere" (click)="resetPassword()">Forgot password?</a>
          </div>

          <div class="forgotPassword">Not a customer?<a class="clickHere" (click)="signup()">Try for free</a></div>
        </div>
      </div>

      <!-- <button *ngIf="isAuthenticated" (click)="logout()"> Logout </button> -->
      <!-- <div style="  text-align: center; margin-top: 10px;">
                 <a [routerLink]="['/forgot']" class="btn btn-link" class="cannotLogin">Forgot account?</a>
      <a [routerLink]="['/register']" class="btn btn-link" class="cannotLogin">Register</a>
                <a style="font-size: 14px; font-weight: 500; color: #87E559;" href="https://www.catchsoftware.com" target="_blank">Powered by Catch</a>
            </div> -->

      <div style="text-align: center; font-size: 12px; font-weight: 200; margin-bottom: 5px">
        {{ prompts.version }}
      </div>
      <div style="text-align: center; font-size: 12px; font-weight: 200; margin-bottom: 5px">Powered by<a class="clickHere" href="https://catchsoftware.com/" target="_blank">Catch Software</a></div>
    </div>
  </form>

  <!-- <div class="loginPageIcon">
        <a href="https://catchsoftware.com/" target="_blank">
            <img src="assets/images/Catch_green@2x.png" alt="Catch Logo">
        </a>
    </div> -->
</div>
